import { Button, Comment, CollapsePanelProps, Modal } from "antd";
import { FC, useState } from "react";
import { useMediaQuery } from "beautiful-react-hooks";
import { StyledPanel } from "./MemberCard/MemberPanel";
import { useWikipedaSearchIfIsNotCurrentUser } from "../../utils/useWikipedaSearchIfIsNotCurrentUser";

export const WikipedaPanel: FC<CollapsePanelProps> = (props) => {
  const [showLinkInModalIframe, setShowLinkInModalIframe] = useState<
    string | undefined
  >(undefined);

  const isSmall = useMediaQuery("(max-width: 780px)");

  const resultQuery = useWikipedaSearchIfIsNotCurrentUser();

  if (!resultQuery.isSuccess) {
    return null;
  }

  return (
    <>
      <Modal
        style={{ top: 8 }}
        footer={null}
        bodyStyle={{ padding: 0 }}
        title={"Arikel auf Wikipedia"}
        width={"99%"}
        visible={!!showLinkInModalIframe}
        onCancel={() => setShowLinkInModalIframe(undefined)}
        destroyOnClose
      >
        <iframe
          title={"iframe-wikipedia"}
          height={window.visualViewport.height - 100}
          width={"100%"}
          src={showLinkInModalIframe}
        />
      </Modal>
      <StyledPanel {...props}>
        {" "}
        <div>
          <Comment
            actions={[
              <Button
                size={"small"}
                type={"link"}
                onClick={() => {
                  if (isSmall) {
                    setShowLinkInModalIframe(
                      resultQuery.data?.content_urls?.mobile?.page
                    );
                  } else {
                    setShowLinkInModalIframe(
                      resultQuery.data?.content_urls?.desktop?.page
                    );
                  }
                }}
              >
                Ganzen Artikel anzeigen
              </Button>,
            ]}
            author={
              <a
                target={"_blank"}
                rel={"noreferrer"}
                href={resultQuery.data?.content_urls?.desktop?.page}
              >
                Wikipedia sagt:
              </a>
            }
            content={<p>{resultQuery.data?.extract}</p>}
          />
        </div>
      </StyledPanel>
    </>
  );
};
